import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

// Variants a product contributes. A product with no real options still carries Shopify's synthetic
// single variant, so it counts as one rather than nothing - the same rule the lookbook ceiling uses.
const countVariants = products => products.reduce((sum, product) => sum + Math.max(product.variants?.nodes?.length || 0, 1), 0);

// One collection per request: `variantsInCollection` takes a single collection, so the endpoint
// cannot answer for several at once - which is why the old ten-id cap is gone rather than raised.
// Pages are followed through the response's ready-made `next` URL, the way the search listings do;
// no `first` is sent, because the endpoint's own default is the widest page its cost allows.
function* getShopifyCollectionProducts({ payload: { collectionIds, signal, onSuccess, onError } }) {
  try {
    const products = [];

    for (const collectionId of collectionIds) {
      let pageUrl = null;

      do {
        const { data } = yield call(fetch, {
          api: api.shopify.collection_products,
          ...(pageUrl ? { url: pageUrl } : { params: { collection_id: collectionId } }),
          signal
        });

        products.push(...data.results);
        pageUrl = data.next;

        // Reported per page rather than per collection: one collection at the lookbook ceiling is
        // several sequential requests, and the picker has nothing else to show meanwhile.
        yield put(actions.shopifyCollectionProductsProgress({ loaded: countVariants(products) }));
      } while (pageUrl);
    }

    yield put(actions.getShopifyCollectionProductsDone({ products }));
    onSuccess && onSuccess(products);
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getShopifyCollectionProductsFailed,
      onError,
      endpoint: api.shopify.collection_products.url
    });
  }
}

export const getShopifyCollectionProductsSaga = takeEvery(types.GET_SHOPIFY_COLLECTION_PRODUCTS_REQUEST, getShopifyCollectionProducts);
